import { useQuery } from '@tanstack/react-query';
import { dvojbojApi } from '../dvojbojApi';

export const dvojbojRankingQueryKey = (categoryId: number) =>
  ['dvojboj-ranking', categoryId] as const;

export const useDvojbojRanking = (categoryId: number | null | undefined) =>
  useQuery({
    queryKey: dvojbojRankingQueryKey(categoryId ?? 0),
    queryFn: () => dvojbojApi.getDvojbojRanking(categoryId!),
    enabled: !!categoryId,
    refetchInterval: 5_000,
  });

export const individualEntryRankingQueryKey = (disciplineId: number) =>
  ['individual-entry-ranking', disciplineId] as const;

export const useIndividualEntryRanking = (disciplineId: number | null | undefined) =>
  useQuery({
    queryKey: individualEntryRankingQueryKey(disciplineId ?? 0),
    queryFn: () => dvojbojApi.getIndividualEntryRanking(disciplineId!),
    enabled: !!disciplineId,
    refetchInterval: 5_000,
  });
